import { useQuery } from "react-query";
import API from "../../axios/API";
import { QUERY_KEYS } from "../keys";
import { GET_ENDPOINTS } from "@/axios/API/endpoints";

const getCountries = async () => {
  const { data } = await API.get(GET_ENDPOINTS.COUNTRIES);
  return data.countries;
};

const useAllCountries = () => useQuery(QUERY_KEYS.COUNTRIES, getCountries);

export default useAllCountries;
